module.exports = __webpack_public_path__ + "media/invite/mark-92fdb6c8.svg";